<div class="fixed inset-0 z-[100000] flex items-center justify-center p-4 transition-opacity duration-200"
    [ngClass]="active ? 'opacity-100' : 'opacity-0 pointer-events-none'"
    style="background-color: rgba(34, 48, 76, 0.55);">

    <div class="relative w-full max-h-[90vh] overflow-y-auto rounded-3xl bg-white p-8 shadow-2xl"
        [ngClass]="content.context === 'media' ? 'max-w-xl' : 'max-w-md'">

        <!-- Cerrar -->
        <button type="button" (click)="close()"
            class="absolute top-4 right-4 w-9 h-9 rounded-full flex items-center justify-center text-gray-500 hover:bg-gray-100 transition"
            [attr.aria-label]="'words.close' | translate">
            <i class="icon icon-close text-lg"></i>
        </button>

        <!-- Título -->
        <h2 class="mt-5 text-center text-xl font-bold tracking-tight text-gray-800">{{ content.title }}</h2>

        <!-- Contenido (todos los tipos) -->
        <div class="mt-4">
            <ng-container *ngIf="(content.context === 'cheatsheet') && content.cheatsheet.content">
                <div class="modal__wrapper" data-simplebar [innerHTML]="content.cheatsheet.content | safe: 'html'"></div>
            </ng-container>

            <div class="modal__wrapper" *ngIf="content.context === 'external_link'">
                <iframe name="embed-iframe" class="w-full"></iframe>
                <div id="embed-code"></div>
            </div>

            <div *ngIf="content.context === 'media'" [ngClass]="{'modal__wrapper': content.media.type === 'IMG'}">
                <div class="modal__body__picture rounded-2xl overflow-hidden" *ngIf="content.media.type === 'IMG'">
                    <img class="w-full" [src]="content.media.storage === 'azure' ? content.media.pictureUrl + '?size=512' : content.media.url">
                </div>

                <div class="rounded-2xl overflow-hidden" *ngIf="content.media.type === 'VID'">
                    <iframe [src]="getUrl(content.media.url, 'video')" allow="fullscreen" allowfullscreen width="100%" class="w-full aspect-video"></iframe>
                </div>

                <div class="rounded-2xl overflow-hidden" *ngIf="content.media.type === 'DOC' || content.media.type === 'PDF'">
                    <iframe [src]="getUrl(content.media.pictureUrl)" allow="fullscreen" allowfullscreen width="100%" class="w-full h-96"></iframe>
                </div>

                <div class="rounded-2xl overflow-hidden" *ngIf="content.media.type === 'EMBED'">
                    <iframe [src]="getUrl(content.media.url)" allow="fullscreen" allowfullscreen width="100%" class="w-full aspect-video"></iframe>
                </div>

                <div class="modal__body__audio" *ngIf="content.media.type === 'SND'">
                    <msc-audio-player [song]="content.media.pictureUrl" [title]="content.media.title"></msc-audio-player>
                </div>
            </div>

            <div class="mt-3 text-sm leading-relaxed text-gray-500 modal-activity__description" *ngIf="content.description"
                [innerHTML]="content.description | safe: 'html'"></div>
        </div>

        <!-- Tiempo -->
        <div class="mt-4 rounded-2xl px-4 py-3 flex items-center gap-2.5" style="background-color: rgba(34, 48, 76, 0.06);">
            <i class="icon icon-clock text-gray-700"></i>
            <p class="text-sm text-gray-700">
                <span class="font-semibold">{{ 'words.estimated-time' | translate }}:</span> {{ internalTimer | duration: true }}
            </p>
        </div>

        <!-- Acciones -->
        <div class="mt-6 grid gap-3" [ngClass]="!session.doneAt ? 'grid-cols-2' : 'grid-cols-1'">
            <button type="button" (click)="close()"
                class="rounded-full border border-gray-200 py-3 text-sm font-semibold text-gray-700 hover:bg-gray-50 transition inline-flex items-center justify-center gap-2">
                <i class="icon icon-clock"></i>
                {{ 'words.not-now' | translate }}
            </button>

            <button type="button" (click)="finished()" *ngIf="!session.doneAt"
                class="rounded-full py-3 text-sm font-semibold text-white bg-primary-700 hover:opacity-95 transition inline-flex items-center justify-center gap-2">
                <i class="icon icon-checkmark"></i>
                {{ 'words.i-finished' | translate }}
            </button>
        </div>

        <!-- Descargar (solo media) -->
        <button type="button" (click)="download()"
            *ngIf="content.context === 'media' && content.media.type !== 'EMBED'"
            class="mt-3 w-full rounded-full border border-gray-200 py-3 text-sm font-semibold text-gray-700 hover:bg-gray-50 transition inline-flex items-center justify-center gap-2">
            <i class="icon icon-download"></i>
            {{ 'words.download' | translate }}
        </button>

        <!-- Volver al inicio -->
        <div class="mt-5 text-center">
            <button type="button" (click)="close()" class="text-xs text-gray-400 hover:text-gray-600 transition">
                {{ 'words.back-to-home' | translate }}
            </button>
        </div>
    </div>
</div>
